import { selectMany, sum } from "../../../omnia"
import { getSpreadingArea, INutritionCalcService } from "../../../services/calcService"
import { StockVm } from "../../../stocks/stockVm"
import { INutritionService, NutrientType, ProductAppInput } from "../../../types"
import { CroppingEditVm } from "../cropping/croppingEditVm"
import { IPlanEditContext } from "../types"
import { CroppingOverride } from "./croppingOverride"
import { ProductApplicationVm } from "./productApplicationVm"

export function calculateAmountInStock(ctxt: IPlanEditContext, stock: StockVm, svc: INutritionService): number {

    if (!stock) return undefined

    let plans = svc.getPlans();
    let currentPlan = ctxt.target;
    let stockId = stock.stockId;
    let manure = stock.isManure();

    let allApplications = selectMany(plans.filter(p => !!p.Applications).map(p => p.Applications));

    let otherApplications = svc.getApplications().filter(a => {

        if (a.Zone) return false;
        if (a.PlanId == currentPlan.NutritionPlanId) return false;

        let planApp = allApplications.find(pa => pa.NutritionPlanProductAppId == a.AppId);
        if (!planApp) return false;

        if (stockId != (manure ? planApp.ManureId : planApp.FertiliserId)) return false;

        return true;

    });

    let required = sum(otherApplications, a => a.ProductAmount);

    for (const a of ctxt.applications) {
        const s = a.stock

        if (s && s.stockId === stockId) {
            const total = a.calculateTotalAmount()
            required += total.totalAmount
        }

    }

    return stock.getAmountInStock() - required;

}


export function useAllStock(ctxt: IPlanEditContext, calcSvc: INutritionCalcService, vm: ProductApplicationVm) {

    const { productApp: app, analysis } = vm

    var croppings = ctxt.getSelectedCropping();

    if (croppings.length <= 0) {
        return;
    }

    const nutrient = app.TargetNutrient

    vm.resetRates();

    var stockToUse = vm.getAmountInStock();
    var totalArea = croppings.map(c => getSpreadingArea(vm.productApp, c.cropping)).reduce((a, b) => a + b);

    const getMaxRate = (cropping: CroppingEditVm) => {

        const nLeftBeforeFieldLimit = ctxt.getNLeftFieldsLimit(cropping, vm.productApp);

        let maxRate = nLeftBeforeFieldLimit === -1 ? -1 : calcSvc.getProductRateForNutrientRate(nLeftBeforeFieldLimit, vm.productApp, cropping.cropping);
        maxRate = Math.floor(maxRate);

        return maxRate;
    }

    const calcRate = (cropping: CroppingEditVm) => {

        const maxRate = (nutrient === NutrientType.N) && Boolean(analysis?.N)
            ? getMaxRate(cropping)
            : - 1

        const rate = vm.roundToProductUnit(stockToUse / totalArea);
        const productRate = maxRate === -1 ? rate : Math.min(maxRate, rate);

        return productRate

    }

    var first = croppings.shift();

    var rate = calcRate(first)

    app.ProductRate = rate;
    vm.lastInputUsed = ProductAppInput.ProductRate;
    vm.updateTargetModel(vm.productApp, false);

    // Override other crops
    croppings.forEach(c => {

        const productRate = calcRate(c)

        if (productRate !== app.ProductRate) {
            const croppingId = c.croppingId;
            const ovr = new CroppingOverride(vm, croppingId)
            ovr.ProductRate = productRate
            vm.setOverride(ovr)
        }

    });

    vm.updateOverridesOnModel();

    // Force refresh
    const value = app.ProductRate;
    vm.productRate = 0;
    vm.productRate = value;
}
